<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="foreword" id="_idContainer000" role="doc-foreword">
<p class="pl-fl-header">“Are you in some kind of trouble?” Cade finally asked.</p>
<p class="pl-fl-roman">Leah turned away. “Why would you ask that?”</p>
<p class="pl-fl-roman">“I don’t know. Something about the way you’ve acted since…well, since I pulled you from the snow. Like you’re scared. Why are you in such a hurry to leave? I thought you were staying in the cabin tonight?”</p>
<p class="pl-fl-roman">She glanced at him. “I never said I was staying. I asked you to give me a ride back, that’s all.”</p>
<p class="pl-fl-roman">“I just want to help.”</p>
<p class="pl-fl-roman">Leah sighed. “I know.”</p>
<p class="pl-fl-roman">“I could take a look at it for you.” Now, why would he offer that up—an attempt to snag her?</p>
<p class="pl-fl-roman">“No.” Her reply was too emphatic.</p>
<p class="pl-fl-roman">He glanced her way, trying to watch her and the road. To his surprise, a timid smile broke through.</p>
<p class="pl-fl-roman">“Not tonight, that is,” she added. She was trying to be friendly, warm up to him, but still, it seemed forced.</p>
<p class="pl-fl-roman">He risked another glance over and caught her eyes—there he saw the truth. She was terrified and hiding something.</p>
<p class="pl-fl-roman"><em class="italic">Who are you, Leah Marks?</em></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Introduction.vue?382889bc